import '../styles/AfterTheDownload.scss';

const AfterTheDownload = () => (
  <div className="atd-wrap">
    <iframe
      className="atd-frame"
      src="https://www.youtube.com/embed/UZtzECEZSck?start=4&autoplay=1&rel=0&modestbranding=1&iv_load_policy=3"
      title="After The Download"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
    />
  </div>
);

export default AfterTheDownload;
